import { render, staticRenderFns } from "./parkCardBox.vue?vue&type=template&id=08978d7f&scoped=true"
import script from "./parkCardBox.vue?vue&type=script&lang=js"
export * from "./parkCardBox.vue?vue&type=script&lang=js"
import style0 from "./parkCardBox.vue?vue&type=style&index=0&id=08978d7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08978d7f",
  null
  
)

export default component.exports